<template>
  <div class="owc-footer" role="contentinfo" ref="footer">
    <OwcFooterContent v-if="loaded" :componentData="componentData" :isEdit="isEditMode" />
  </div>
</template>

<script lang="ts">
import ComponentInitializeDispatcher from '@owc-utils/Mixins/ComponentInitializeDispatcher';
import { FooterComponent, FooterComputed, FooterData, FooterMethods } from '@owc-packages/Footer/src/Footer';
import { Props } from '../../_types/ComponentInitializeDispatcher';
/**
 * `Footer` - Footer for OneWeb - Footer is the last module of the page. It contains links that help the user navigate through the website..
 */

export default (ComponentInitializeDispatcher as FooterComponent).extend<
  FooterData,
  FooterMethods,
  FooterComputed,
  Props
>({
  name: 'owc-footer',
  components: {
    OwcFooterContent: () => import('./FooterContent.vue'),
  },
  data() {
    return {
      loaded: false,
    };
  },
  mounted() {
    if (window.top?.aemNamespace && window.top?.aemNamespace.pageEnvironmentVariables.runMode === 'PUBLISH') {
      this.lazyLoad();
    } else {
      this.loaded = true;
    }
  },
  methods: {
    lazyLoad() {
      const observer = new IntersectionObserver(
        entries => {
          if (entries[0].isIntersecting) {
            this.loaded = true;
            observer.disconnect();
          }
        },
        { threshold: 0.5 },
      );
      observer.observe(this.$refs.footer as HTMLElement);
    },
  },
});
</script>

<style lang="scss">
@import '@owc-styles/utils/z-index-list';

$footerModuleName: 'owc-footer';

.#{$footerModuleName} {
  position: relative;

  z-index: $z-index-footer;

  $minHeight: 113px;
  $selectorHeights: (
    '.owc-footer-movetotop': 160px,
    '.owc-footer-newsletter': 128px,
    '.owc-footer-sitemap': 300px,
  );

  min-height: $minHeight;

  @each $selector, $height in $selectorHeights {
    &:has(#{$selector}) {
      min-height: $minHeight + $height;

      $minHeight: $minHeight + $height;
    }
  }

  background: var(--wb-black);
}
</style>
